import { createLogger } from "redux-logger";
import { createStore, applyMiddleware, compose } from "redux";
import { not, contains } from "ramda";
import { routerMiddleware } from "react-router-redux";
import createHistory from "history/createBrowserHistory";
import createSagaMiddleware from "redux-saga";

const history = createHistory();

export default (rootReducer, rootSaga) => {

	const middleware = [];
	const enhancers = [];

	const sagaMiddleware = createSagaMiddleware();
	const historyMiddleware = routerMiddleware(history);

	if (process.env.NODE_ENV === "development") {
		const SAGA_LOGGING_BLACKLIST = ["EFFECT_TRIGGERED", "EFFECT_RESOLVED", "EFFECT_REJECTED"];
		const logger = createLogger({
			predicate: (getState, { type }) => not(contains(type, SAGA_LOGGING_BLACKLIST))
		});
		middleware.push(logger);
	} else console.log = function () { };

	middleware.push(sagaMiddleware);
	middleware.push(historyMiddleware);

	enhancers.push(applyMiddleware(...middleware));

	const store = createStore(rootReducer, compose(...enhancers));
	sagaMiddleware.run(rootSaga);
	return store;
};

export { history };


// WEBPACK FOOTER //
// ./src/reducers/configureStore.js